import { request } from '../client'
import type { LoginResponse } from '../types'

export interface DebugLoginResponse extends LoginResponse {
  /** Score session auto-completed against score-mock; null if that step failed. */
  score_session: { token: string; expires_at: string | null } | null
}

export function debugLogin(): Promise<DebugLoginResponse> {
  return request('/debug/login', { method: 'POST' })
}

export function resetDatabase(): Promise<{
  collections_reset: number
  clubname: string
}> {
  return request('/debug/reset', { method: 'POST' })
}

export function seedMockData(): Promise<{
  club_id: string
  teams: number
  players: number
  staff: number
  matches: number
  /** Score-side seeding (staff, club ids, auto-links); false if score-mock was unreachable. */
  score_seeded: boolean
  score_staff?: number
  linked_teams?: number
  linked_matches?: number
}> {
  return request('/debug/seed', { method: 'POST' })
}
